import { createBrowserHistory } from 'history';

export const spenditHistory = createBrowserHistory();
